import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
  state() {
    return {
      user: null,
      token: localStorage.getItem("token"),
      name: localStorage.getItem("name"),
      email: localStorage.getItem("email"),
      address: localStorage.getItem("address"),
      phone: localStorage.getItem("phone"),
      type: localStorage.getItem("type"),
    };
  },
  mutations,
  actions,
  getters,
  namespaced: false
};